<template>
    <div class="mb-3">
        <h3>Finished</h3>
        <p>
            Your payment for Transient Parking at HIO airport has been accepted.
        </p>
        <p>
            Your payment Id is {{ store.paymentId }}
        </p>
        <p>
            You will receive an email receipt with your payment information shortly.
        </p>
    </div>
</template>

<script setup>
    import { useStore } from './store';

    const store = useStore();
</script>